
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IUserRegistration } from '../api/auth.interfaces';
import Stripe from '@/features/stripe/components/Stripe.vue';
import { EventBus } from '../../../event-bus';

@Component({
  name: 'register',
  components: {
    Stripe,
  },
})
export default class Register extends Vue {
  // References

  $refs: {
    form: any;
    stripe: any;
  };

  // Locals

  loading: boolean = false;
  valid: boolean = false;
  errors: string[] = [];
  user: IUserRegistration = {} as IUserRegistration;

  handleRegister(event: any) {
    this.errors = [];
    var self = this;
    if (this.$refs.form.validate()) {
      this.loading = true;
      this.register(self.user);
      // if (self.user.stripeCoupon === '' && self.user.stripeCoupon.includes('beta')) {
      //   this.register(self.user);
      // } else {
      //   this.$refs.stripe.pay().then((data: any) => {
      //     if (data.error) {
      //       self.errors.push(data.error.message);
      //     } else {
      //       self.user.stripeToken = data.token.id;
      //       this.register(self.user);
      //     }
      //   });
      // }
    }
  }

  register(user: IUserRegistration) {
    var self = this;
    self.$store
      .dispatch('auth/register', user)
      .then((response: IApi<string>) => {
        EventBus.$emit('api-success', { message: `${user.email} registered successfully!` });
        self.$router.push({ name: 'login' });
        self.loading = false;
      })
      .catch((error: any) => {
        self.loading = false;
      });
  }
}
